import Hero from '../components/Landing.tsx/Hero';
import StatisticsSection from '../components/Landing.tsx/StatisticsSection';
import TestimonialsSection from '../components/Landing.tsx/Testimonials';
import CommunitySection from '../components/Landing.tsx/CommunitySection';
import Faq from '../components/Landing.tsx/FAQ';
import CallToAction from '../components/Landing.tsx/CTA';
import NewsletterSection from '../components/Landing.tsx/NewsLetterSection';
import Footer from '../components/Landing.tsx/Footer';
import RandomFacts from '../components/Landing.tsx/RandomFacts';
import PopularCourses from '../components/Landing.tsx/PopularCourses';
import CountdownBanner from '../components/Landing/CountdownBanner';
import { useBanner } from '../context/BannerContext';
import { PageSEO } from '../SEO';
import siteMetadata from '../data/siteMetadata';

/**
 * Section order follows the conversion narrative: hero → proof → the product
 * itself → trust → objections → the ask. `StatisticsSection` moved above the
 * catalogue, `RandomFacts` moved out from between the courses and the social
 * proof, and the FAQ now answers objections *before* the closing CTA rather
 * than after it.
 *
 * Each band owns its own `tone`, and read top to bottom they give the page a
 * colour rhythm rather than the two near-identical off-whites it had:
 *
 *   Hero            default
 *   Statistics      blue    (renders only when real figures are passed)
 *   PopularCourses  alt
 *   Testimonials    gold
 *   Community       default
 *   RandomFacts     blue
 *   FAQ             alt
 *   CTA             ink     ← the one high-contrast moment, spent on the ask
 *   Newsletter      default
 *
 * No two tinted bands sit next to each other with or without the statistics
 * band, and `ink` is used exactly once so it still reads as an event.
 */
const Home = () => {
  const { banner, loading } = useBanner();

  return (
    <>
      <PageSEO title={siteMetadata.title} description={siteMetadata.description} />
      <div className="min-h-screen bg-background-main text-text-primary">
        {/* Show banner if active and not loading */}
        {!loading && banner?.isActive && (
          <CountdownBanner
            title={banner.title}
            countdownDate={banner.countdownDate}
            thumbnailOverlay={banner.thumbnailOverlay}
          />
        )}

        {/* The skip link in the header targets this. */}
        <main id="main" tabIndex={-1}>
          <Hero />

          <StatisticsSection />
          <PopularCourses />
          <TestimonialsSection />
          <CommunitySection />
          <RandomFacts />
          <Faq />
          <CallToAction />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
